import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const FRAISSCOLARITE_URL = `${backendUrl}/api/fraisscolarite/`;

class FraisscolariteService {
	async getAllFraisscolarites() {
		try {
			const response = await axios.get(FRAISSCOLARITE_URL);
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	getFraisscolarite(id) {
		return axios.get(`${FRAISSCOLARITE_URL}${id}/`);
	}

	createFraisscolarite(data) {
		return axios.post(FRAISSCOLARITE_URL, data).catch((error) => {
			console.error('Erreur lors de la création du Fraisscolarite', error);
			throw error;
		});
	}

	updateFraisscolarite(id, data) {
		return axios.put(`${FRAISSCOLARITE_URL}${id}/`, data);
	}

	deleteFraisscolarite(id) {
		return axios.delete(`${FRAISSCOLARITE_URL}${id}/`);
	}
}

export default new FraisscolariteService();
